__turbopack_context__.v({
  "content": "OtherMembersPersonalFoldersAccordion-module__zGMQ5W__content",
  "root": "OtherMembersPersonalFoldersAccordion-module__zGMQ5W__root",
});
